import {http} from 'lib/httpAxios'

export default {
  retrieveTypesData (parameters) {
    return http.get(`/documents/types/all`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveAccountConfigurationData (parameters) {
    return http.post(`/documents/configuration/${parameters.accountCode}`, parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/documents.js